/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { useState } from 'react';
import { AlertBar } from '@blend/enterprise-components';
import { ToastContext } from 'blb-contexts/Toast';
import { Toast } from './Toast';
import { css, StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
  toast: {
    marginBottom: 16,
  },
  toastContainer: {
    left: '50%',
    margin: 'auto',
    position: 'absolute',
    top: 200,
    transform: 'translate(-50%, -50%)',
  },
});

export namespace ToastProvider {
  export interface Props {
    children: JSX.Element | JSX.Element[];
  }
}

export interface ToastOpts {
  id: number;
  message: string;
  theme: AlertBar.ThemeType;
}

let toastCount = 0;
export const ToastProvider: React.FC<ToastProvider.Props> = ({ children }) => {
  const [toasts, setToasts] = useState<ToastOpts[]>([]);

  const addToast = ({ message, theme }: Omit<ToastOpts, 'id'>) => {
    const id = toastCount++;
    const toast = { id, message, theme };
    setToasts([...toasts, toast]);
  };

  const remove = (id: number) => {
    const newToasts = toasts.filter((t: ToastOpts) => t.id !== id);
    setToasts(newToasts);
  };
  // avoid creating a new fn on every render
  const onDismiss = (id: number) => () => remove(id);

  return (
    <ToastContext.Provider value={{ addToast, remove }}>
      {children}
      <div className={css(styles.toastContainer)}>
        {toasts.map(({ message, id, theme }) => (
          <div className={css(styles.toast)} key={id}>
            <Toast dismiss={onDismiss(id)} message={message} theme={theme} />
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
};
